<template>
    <v-layout row class="mobile-description">
        <v-flex xs3 md2>
            <v-avatar
                color="grey lighten-4"
                size="70"
            >
                <img :src="getDrSmassPersonas" alt="avatar">
            </v-avatar>
        </v-flex>

        <v-flex xs9 md10 class="description-text">
            <div v-html="text('db.global.TYPE_GTS_MOBILE_PERSONA')"></div>
            <div class="margin-right-xxs" v-model="route">
                <div v-for="router in routes">
                    <span v-if="router === 'PF_HomePage'" v-html="text('db.global.TYPE_GTM_MOBILE_HOME_TEXT')">
                    </span>
                    <span  v-if="router ==='PF_StartQuestionsPage'" v-html="text('db.product.PROD_EXPLAIN_START_QUESTIONS')">
                    </span>
                    <span  v-if="router ==='PF_GeneralQuestionsPage'" v-html="text('db.product.PROD_EXPLAIN_GENERAL_QUESTIONS')">
                    </span>
                    <span  v-if="router ==='PF_MainSymptomPage'" v-html="text('db.product.PROD_EXPLAIN_CHOOSE_MAIN_SYMPTOM')">
                    </span>
                    <span  v-if="router ==='PF_RelatedSymptomsPage'" v-html="text('db.product.PROD_EXPLAIN_RELATED_SYMPTOMS_LIST')">
                    </span>
                    <span  v-if="router ==='PF_SymptomQuestions'" v-html="text('db.product.PROD_EXPLAIN_MAIN_SYMPTOM')">
                    </span>
                    <span  v-if="router ==='PF_SharedQuestions'" v-html="text('db.product.PROD_EXPLAIN_SHARED_QUESTIONS')">
                    </span>
                    <span  v-if="router ==='PF_EvaluationPage'" v-html="text('db.product.PROD_EXPLAIN_SCORING')">
                    </span>
                    <span v-else>
                    </span>
                </div>
            </div>
        </v-flex>
    </v-layout>
</template>

<script>
    import {mapGetters} from "vuex";

    export default {
        name: "Description",
        data() {
          return {
              route: '',
              routes:[]
          }
        },
        computed: {
          ...mapGetters({
              getDrSmassPersonas: 'ChatBotStore/getDrSmassPersonas',
          })
        },
        mounted: function(){
            this.route = this.$route.name;
            this.routes.push(this.route);
        }
    }
</script>

<style lang="scss" >


</style>



// WEBPACK FOOTER //
// src/pathfinder/components/shared/Description.vue